import { TrendingUp, Users, Award, Handshake, IndianRupee, Sparkles, MapPin, Shield } from "lucide-react";

const franchiseBenefits = [
  { icon: TrendingUp, label: "Growing Market", desc: "The Indian preschool industry is expanding at 20%+ annually", color: "from-emerald-500 to-teal-600" },
  { icon: Award, label: "Trusted Brand", desc: "Rooted in Sanatan values with modern pedagogy — a rare combo", color: "from-orange-500 to-red-500" },
  { icon: Handshake, label: "Full Support", desc: "Curriculum, training, marketing, admissions playbook — all included", color: "from-amber-500 to-orange-600" },
  { icon: Shield, label: "Proven System", desc: "Time-tested SOPs for every classroom, event and parent touchpoint", color: "from-sky-500 to-blue-600" },
  { icon: Users, label: "Parent Trust", desc: "Bharatiya families deeply value sanskaar-based early learning", color: "from-fuchsia-500 to-purple-600" },
  { icon: IndianRupee, label: "Attractive ROI", desc: "Scalable revenue with regular fee cycles + program add-ons", color: "from-yellow-500 to-orange-500" }
];

const franchiseSteps = [
  { n: "1", title: "Apply Online", desc: "Fill our short franchise interest form" },
  { n: "2", title: "Discovery Call", desc: "We understand your city, capital and dream" },
  { n: "3", title: "Site & Approval", desc: "Location scout, franchise agreement & investment plan" },
  { n: "4", title: "Setup & Training", desc: "We help you build the campus + train your team" },
  { n: "5", title: "Grand Opening", desc: "Marketing launch, first parent meets & admissions" },
  { n: "6", title: "Grow Together", desc: "Ongoing support, audits & community of partners" }
];

const FranchiseInfographic = () => (
  <section className="py-16 bg-white" data-testid="franchise-infographic">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <span className="inline-block text-[10px] font-bold text-orange-700 tracking-widest uppercase mb-2">Why Partner With Us</span>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-stone-800 mb-3">A Business Rooted in Purpose</h2>
        <p className="text-stone-600 text-sm md:text-base">
          Aadi Gayanam is more than a play school — it is a mission. Partner with us and build a business that also builds Bharat.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
        {franchiseBenefits.map((b) => {
          const Icon = b.icon;
          return (
            <div key={b.label} className="p-5 rounded-3xl bg-white border border-orange-100 shadow-md hover:shadow-2xl transition-all hover:-translate-y-1" data-testid={`franchise-benefit-${b.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${b.color} flex items-center justify-center shadow mb-3`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-display text-lg font-bold text-stone-800 mb-1">{b.label}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{b.desc}</p>
            </div>
          );
        })}
      </div>

      {/* Journey to franchise */}
      <div className="max-w-5xl mx-auto rounded-3xl overflow-hidden shadow-xl border border-orange-100" data-testid="franchise-steps">
        <div className="p-6 bg-gradient-to-br from-orange-950 via-red-950 to-amber-950 text-white">
          <div className="flex items-center gap-3">
            <Sparkles className="w-6 h-6 text-yellow-200" />
            <div>
              <p className="text-[10px] font-bold text-yellow-200 uppercase tracking-widest">Your Franchise Journey</p>
              <h3 className="font-display text-2xl font-bold">6 Simple Steps to Open Your Aadi Gayanam</h3>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {franchiseSteps.map((s) => (
            <div key={s.n} className="flex items-start gap-3 p-3 rounded-xl bg-orange-50/60 border border-orange-100">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-red-500 text-white flex items-center justify-center font-bold shadow">
                {s.n}
              </div>
              <div>
                <p className="font-display font-bold text-stone-800">{s.title}</p>
                <p className="text-xs text-stone-600">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default FranchiseInfographic;
